var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9872 4.5H15.8108M2.25781 4.5H10.7284M12.9872 13.5H15.8108M2.25781 13.5H10.7284M7.34017 9H15.8108M2.25781 9H5.08134",
    stroke: "#5B5B5B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8599 5.625C12.4836 5.625 12.9893 5.12132 12.9893 4.5C12.9893 3.87868 12.4836 3.375 11.8599 3.375C11.2361 3.375 10.7305 3.87868 10.7305 4.5C10.7305 5.12132 11.2361 5.625 11.8599 5.625Z",
    stroke: "#5B5B5B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21144 10.125C6.8352 10.125 7.34085 9.62132 7.34085 9C7.34085 8.37868 6.8352 7.875 6.21144 7.875C5.58769 7.875 5.08203 8.37868 5.08203 9C5.08203 9.62132 5.58769 10.125 6.21144 10.125Z",
    stroke: "#5B5B5B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8599 14.625C12.4836 14.625 12.9893 14.1213 12.9893 13.5C12.9893 12.8787 12.4836 12.375 11.8599 12.375C11.2361 12.375 10.7305 12.8787 10.7305 13.5C10.7305 14.1213 11.2361 14.625 11.8599 14.625Z",
    stroke: "#5B5B5B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionOption);
export default __webpack_public_path__ + "static/media/actionOption.153a0db2c7a34808d89d6c41f672a631.svg";
export { ForwardRef as ReactComponent };